import React from "react";
import { Link, useNavigate } from "react-router-dom";
// import { motion } from "framer-motion"; // Optional: for animations

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="bg-teal min-h-screen flex flex-col items-center justify-center p-4">
      <div className="bg-forestGreen/80 rounded-xl shadow-dashboardshadow max-w-lg w-full p-6 md:p-8">
        <div className="flex flex-col items-center text-center">
          {/* 404 Number */}
          <h1 className="text-yellow text-7xl md:text-9xl font-bold">404</h1>

          {/* Title */}
          <h2 className="text-white text-xl md:text-2xl font-medium mt-4 uppercase">
            Page Not Found
          </h2>

          {/* Description */}
          <p className="text-doubleextralightwhite text-sm md:text-base mt-4 max-w-md">
            We couldn't find the page you're looking for. It might have been
            removed, had its name changed, or is temporarily unavailable.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mt-8 w-full max-w-xs">
            <button
              onClick={handleGoBack}
              className="bg-transparent border border-doubleextralightwhite hover:border-yellow text-white rounded-md py-3 px-6 text-sm font-medium transition-all duration-200 flex-1"
            >
              Go Back
            </button>

            <Link
              to="/"
              className="bg-yellow hover:bg-yellow/90 text-black rounded-md py-3 px-6 text-sm font-medium transition-all duration-200 flex-1 flex items-center justify-center"
            >
              Home Page
            </Link>
          </div>
        </div>
      </div>

      {/* Additional Call-to-Action */}
      <div className="mt-8 text-center">
        <p className="text-white text-sm">
          Having trouble finding what you need?
        </p>
        <Link
          to="/contact"
          className="text-yellow text-sm hover:underline mt-1 inline-block"
        >
          Contact Support
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
